
import './index.less';
import Rater from 'vux/src/components/rater/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


import util from '@/javascript/util'
import Cpts030 from '@/components/public-components/cpts030/index.vue'
import home from '@/components/public-components/home/index.vue'

import bus from '@/javascript/bus'

import XDialog from 'vux/src/components/x-dialog/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'


export default {
directives: {
TransferDom
},
components: {
Rater,
Cell,
Group,
XTextarea,
Cpts030,
XDialog,
home
},
data() {
return {
minHeight:'',
evalList:[],
evalItem:[],
level:['一般','一般','合格','好','很棒','超赞'],
evalWorld:'',
showHideOnBlur:false,
commentSuccess:false,
referWords:'',
referList:['请先完成评分,再提交','多说两句吧,请输入15个字以上,再试试'],
showItem:'',
maxFileLen: 10,
fileList:[],
typeKind: 'commentSave'
}
},
mounted() {

this.minHeight = document.documentElement.clientHeight;
this.init()

},
methods: {
init:function(){
this.$http.get('/api/wtcp-comment/public/evaluation/getSatisfaction?access_token='+ bus.userInfo.access_token + '&appCode=' + this.$route.params.appCode + '&moduleCode=' + this.$route.params.moduleCode).then((response) => {
this.showItem = response.data.status
if(this.showItem == 0){
}else{
this.evalList = response.data.data
this.evalItem = response.data.data.itemTranslateList ? response.data.data.itemTranslateList : []
this.evalItem.map((item) => {
if(item.val = 'null'){
item.val = 0
}
})
}
})
},
onFileAdd(val) {
this.fileList = this.fileList.concat(val)
},
onFileDel(index) {
this.fileList.splice(index, 1)
},
submitEval:function(){
this.evalWorld = this.evalWorld.replace(/\s+/g, "");

const issuerName = bus.userInfo.user.name == null ?  bus.userInfo.user.phone.substr(0,3) + '*****' + bus.userInfo.user.phone.substr(8) : bus.userInfo.user.name

let evalResult= [];
evalResult = this.evalItem.map(item => {
return {
itemId: item.itemId,
val:item.val
}
})
if(this.showItem == 0){
evalResult = []
this.evalList.id = ''
if( this.evalWorld == '' || this.evalWorld.length <15){
this.showHideOnBlur = true;
this.referWords = this.referList[1]
}else{
const param = {
evaluationEntity: {
checkedItemList: evalResult,

content: this.evalWorld,
fileIds: this.fileList,
issuer: issuerName,
deptCode: this.DEPT_CODE.DEPTCODE
},
subjectEntity: {
appCode: this.$route.params.appCode,
identifer: this.$route.params.id,
moduleCode: this.$route.params.moduleCode,
orgId: bus.userInfo.user.id,
satisfactionId: this.evalList.id,
title: this.$route.params.name,
deptCode: this.DEPT_CODE.DEPTCODE
}
}
this.$http.post('/api/wtcp-comment/public/evaluation?access_token='+ bus.userInfo.access_token, param).then((response) => {

if(response.data.status === 1){
this.commentSuccess = true;
this.referWords = this.referList[2]
const _this = this
setTimeout(() => {
_this.$router.go(-1)
}, 2000)
}else{

}
})
}

}else{
let score= [];
score = this.evalItem.map(item => {
return item.val
})
const scoreNum =score.indexOf(0)
if( scoreNum != -1 ){
this.showHideOnBlur = true;
this.referWords = this.referList[0]
}else if( this.evalWorld == '' || this.evalWorld.length <15){
this.showHideOnBlur = true;
this.referWords = this.referList[1]
}else{
const param = {
evaluationEntity: {
checkedItemList: evalResult,
content: encodeURI(this.evalWorld),
fileIds: this.fileList,
issuer: issuerName,
},
subjectEntity: {
appCode: this.$route.params.appCode,
identifer: this.$route.params.id,
moduleCode: this.$route.params.moduleCode,
orgId: bus.userInfo.user.id,
satisfactionId: this.evalList.id,
title: this.$route.params.name,
}
}
this.$http.post('/api/wtcp-comment/public/evaluation?access_token='+ bus.userInfo.access_token, param).then((response) => {

if(response.data.status === 1){
this.commentSuccess = true;
this.referWords = this.referList[2]
}else{

}
})
}
}
},
showOriginal:function(){
this.$router.go(-1)
}
}
}
